<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4 mb-7">Cadastro de Música de Espera</div>
      <v-row align="baseline" dense>
        <v-col cols="6">
          <v-text-field
            dense
            v-model="form.description"
            :counter="30"
            label="Descrição"
            outlined
            :error-messages="descriptionErrors"
            @input="
              $v.form.description.$touch();
              form.description = $event.toUpperCase().trim();
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-file-input
            outlined
            dense
            show-size
            counter
            multiple
            accept="audio/wav"
            label="Escolha os áudios"
            v-model="form.files"
            prepend-icon=""
            append-icon="mdi-file-music"
          >
            <template v-slot:selection="{ text }">
              <v-chip small label color="grey">{{ text }}</v-chip>
            </template>
          </v-file-input>
        </v-col>
      </v-row>
      <div v-for="n in 3" :key="n">
        <v-divider vertical />
      </div>
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'

import { validateData, validateComputed } from '../_validates'
import musicaEmEsperaHttpService from '../_services/musicaEmEsperaHttpService'

export default {
  name: 'CadastroAudio',
  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      files: [],
    },
    text: '',
    snackbar: false,
    showSkeleton: false,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
  },

  methods: {
    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        await musicaEmEsperaHttpService.postMusicaEmEspera(this.form)
        this.$router.push({ name: 'Espera' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Espera' })
    },
  },
}
</script>
